import * as zod from "zod";

export interface ContaVm {

    id: number,
    accountHash: string,
    agencia: string,
    contaCorrente: string,
    bancoId: number,
    numeroBanco: number,
    descricaoBanco: string
    descricaoConta: string
}


export const zodContaVm = zod.object({
    id: zod.number(),
    accountHash: zod.string(),
    contaCorrente: zod.string(),
}, {message: "Selecione uma conta"}).refine((val) => val != null);
